import { memo, ReactNode } from 'react'

import { useServiceUsage } from 'hooks'

import { Container, Grid, makeStyles } from '@material-ui/core'
import { CSSProperties } from '@material-ui/core/styles/withStyles'

import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
    container: {
        padding: theme.spacing(0, 3)
        // overflow: 'overlay' @TODO check how it works without this extra overflow. It should be removed to fix position: sticky on qg view page
    },
    gridContainer: {
        [theme.breakpoints.up('md')]: {
            minHeight: '100vh'
        }
    },
    // 100px - height of LimitNotification element
    notificationWrapper: {
        minHeight: 'calc(100vh - 100px)'
    },
    videoPanel: {
        background: '#FAFAFA'
    }
}))

type Props = {
    children: JSX.Element
    sidePanel?: ReactNode
    overflow?: CSSProperties['overflow']
}

export const DesktopPlaybookContainer = memo(({ children, sidePanel }: Props) => {
    const classes = useStyles()

    const { notificationIsShown } = useServiceUsage()

    return (
        <Container className={classes.container} maxWidth={false}>
            <Grid
                container
                className={clsx(classes.gridContainer, {
                    [classes.notificationWrapper]: notificationIsShown
                })}
            >
                <Grid item xs={12} md={sidePanel ? 8 : 12} className={classes.videoPanel}>
                    {children}
                </Grid>
                {sidePanel && (
                    <Grid item xs={12} md={4}>
                        {sidePanel}
                    </Grid>
                )}
            </Grid>
        </Container>
    )
})
